/**
 * Light-theme tokens copied from the Android Jigsaw Muse app
 * (`android-jigsaw-muse/puzzle-app/src/theme.js` LIGHT_TOKENS, AppShell, PlayScreen, PlayToolbar,
 * PageHeroBackdrop, boardMat).
 * Keep in sync when the native app changes. Screenshots depict the LIGHT theme only.
 */

export const androidLightTokens = {
    shellBg: "#f2f2f7",
    homeShellBg: "#f4f7f6",
    shellText: "#0f1419",
    shellTextMuted: "rgba(15, 23, 42, 0.65)",
    cardBg: "#ffffff",
    sheetBg: "#f2f2f7",
    cardBorder: "rgba(15, 23, 42, 0.08)",
    accent: "#d9643a",
    divider: "rgba(15, 23, 42, 0.12)",
    trayBg: "#ebe6df",
    trayBorder: "rgba(139, 90, 43, 0.28)",
};

/** Play screen: white toolbar strip under the nav row (PlayScreen `toolbar`). */
export const androidPlayToolbarBg = "#ffffff";
export const androidPlayToolbarBorder = "rgba(15, 23, 42, 0.08)";

/** Play screen gear icon colour. */
export const androidPlayGearColor = "#f97316";

/** Default play mat — "Off-White" in `board/boardMat.js`. */
export const androidDefaultMatHex = "#FAFAFA";

/** Per-tool icon colours from `PlayToolbar.js`. */
export const androidToolbarColors = {
    mute: "#3b82f6",
    sweep: "#f97316",
    hint: "#eab308",
    zoomIn: "#22c55e",
    zoomOut: "#14b8a6",
    preview: "#a855f7",
    basket: "#ec4899",
};

/** AppShell canvas colour per tab (light theme). */
export const androidTabCanvas = {
    home: "#F9FAFB",
    library: "#FAFAFC",
    packs: "#FFFBF5",
    settings: "#F8FAFC",
};

/** AppShell bottom bar = hero band colour of the active tab (`heroBandColor`). */
export const androidTabBand = {
    home: "#3b82f6",
    library: "#14b8a6",
    packs: "#D97706",
    settings: "#A78BFA",
};

/** Gallery pills / cards (GalleryCategoryPills, PuzzleCard) — light. */
export const androidGalleryLight = {
    chipSelectedBg: "#1E293B",
    chipSelectedBorder: "#1E293B",
    chipBg: "#FFFFFF",
    chipBorder: "#E2E8F0",
    chipLabel: "#334155",
    cardBg: "#FFFFFF",
    cardBorder: "rgba(226, 232, 240, 0.8)",
    cardTitle: "#1C1917",
};
